import { defineStore } from "pinia";
import { useCsrfStore } from "@/stores/csrf";
import { queryString } from "@/helpers";
export const useAuthentication = defineStore("authentication", {
    state: () => ({
        permissions: {},
        currentUser: undefined,
        multiFactorQr: undefined,
        multiFactorCodes: undefined,
    }),
    actions: {
        //
        // LOGIN
        //
        async loginUser(email, password) {
            const { fetch } = useCsrfStore();
            if (email && password) {
                const response = (await fetch("POST")("login", {
                    email,
                    password,
                    remember: true,
                }));
                if (!response?.two_factor) {
                    this.fetchCurrentUser();
                }
                return !!response?.two_factor;
            }
            return undefined;
        },
        async loginMultiFactorChallenge(code) {
            const { fetch } = useCsrfStore();
            if (code) {
                await fetch("POST", 204, "string")("two-factor-challenge", { code });
                this.fetchCurrentUser();
            }
        },
        async logoutUser() {
            const { fetch } = useCsrfStore();
            await fetch("POST", 204, "string")("logout");
        },
        //
        // FETCH DATA
        //
        async fetchCurrentUser() {
            const { fetch } = useCsrfStore();
            const response = (await fetch("GET")("employees/current"));
            this.currentUser = response;
            return response;
        },
        async fetchCurrentUserQrCode() {
            const { fetch } = useCsrfStore();
            const response = (await fetch("GET")("user/two-factor-qr-code"));
            this.multiFactorQr = response;
            return response;
        },
        async fetchCurrentUserRecoveryCodes() {
            const { fetch } = useCsrfStore();
            const response = (await fetch("GET")("user/two-factor-recovery-codes"));
            this.multiFactorCodes = response;
            return response;
        },
        //
        // ROUTE GUARDING
        //
        async confirmPassword(password) {
            const { fetch } = useCsrfStore();
            await fetch("POST")("user/confirm-password", { password });
        },
        //
        // MULTI FACTOR AUTH SETUP
        //
        async setMultiFactorEnabled(enabled) {
            const { fetch } = useCsrfStore();
            await fetch(enabled ? "POST" : "DELETE")("user/two-factor-authentication");
            await this.fetchCurrentUser();
        },
        async submitMultiFactorChallenge(code) {
            const { fetch } = useCsrfStore();
            await fetch("POST")("user/confirmed-two-factor-authentication", { code });
        },
        //
        // UPDATE PASSWORD
        //
        async updatePassword(form) {
            const { fetch } = useCsrfStore();
            await fetch("PUT")("user/password", form);
        },
        //
        // FETCH PERMISSIONS
        //
        hasPermission(permission) {
            if (!this.currentUser || !this.currentUser.permissions)
                return false;
            let access = false;
            this.currentUser.permissions.forEach((perm) => {
                if (perm.name == permission)
                    access = true;
            });
            return access;
        },
        async fetchUserCan(actions) {
            const { fetch } = useCsrfStore();
            const response = (await fetch("GET")(`can${queryString({ actions: actions.join(",") })}`));
            this.permissions = {
                ...this.permissions,
                ...response,
            };
            return response;
        },
    },
});
